import { joinUrl } from '@root/src/lib/joinUrl';
const objAsParams = (obj) => {
    const params = Object.keys(obj)
        .map((key) => {
        return `${key}=${obj[key]}`;
    })
        .join('&');
    return `?${params}`;
};
const initFiltersFromLocalStorage = () => {
    let threads;
    let pageSize;
    let orderBy;
    try {
        // Try to read from local storage
        orderBy = JSON.parse(localStorage.getItem('gu.prefs.discussion.order') || '{}');
        threads = JSON.parse(localStorage.getItem('gu.prefs.discussion.threading') || '{}');
        pageSize = JSON.parse(localStorage.getItem('gu.prefs.discussion.pagesize') || '{}');
    }
    catch (error) {
        // Sometimes it's not possible to access localStorage, we accept this and don't want to
        // capture these errors
        return {
            orderBy: 'newest',
            pageSize: 25,
            threads: 'collapsed',
        };
    }
    // If we found something in LS, use it, otherwise return defaults
    return {
        orderBy: orderBy && orderBy.value ? orderBy.value : 'newest',
        threads: threads && threads.value ? threads.value : 'collapsed',
        pageSize: pageSize && pageSize.value ? pageSize.value : 25,
    };
};
const buildParams = (filters) => {
    return {
        // Frontend uses the 'recommendations' key to store this options but the api expects
        // 'mostRecommended' so we have to map here to support both
        orderBy: filters.orderBy === 'recommendations'
            ? 'mostRecommended'
            : filters.orderBy,
        pageSize: filters.pageSize,
        displayThreaded: filters.threads === 'collapsed' || filters.threads === 'expanded',
    };
};
export const getCommentContext = async (ajaxUrl, commentId) => {
    const url = joinUrl([ajaxUrl, 'comment', commentId.toString(), 'context']);
    const filters = initFiltersFromLocalStorage();
    const params = buildParams(filters);
    return fetch(url + objAsParams(params))
        .then((response) => {
        if (!response.ok) {
            throw Error(response.statusText ||
                `getCommentContext | An api call returned HTTP status ${response.status}`);
        }
        return response;
    })
        .then((response) => response.json())
        .catch((error) => {
        window.guardian.modules.sentry.reportError(error, 'get-comment-page');
    });
};
